export default "__VITE_ASSET__D_M051QQ__"